import Swiper, {Navigation, Pagination, Mousewheel, EffectFade, Autoplay, Lazy} from "swiper"

Swiper.use([Navigation, Pagination, Mousewheel, EffectFade, Autoplay, Lazy])
import "jquery.ripples"

// ОБЫЧНЫЕ СЛАЙДЕРЫ==============================================================================
document.addEventListener("DOMContentLoaded", () => {
    // количество слайдов на странице
    let slidesQuantity = document.querySelectorAll(".swiper-slide").length
    const portfolioTopSlider = new Swiper(".portfolio-detail__top-slider", {
        loop: true,
        // slidesPerView: "auto",
        // centeredSlides: true,
        // centerInsufficientSlides: true,
        lazy: {
            loadPrevNext: true,
        },
        loopedSlides: 15,
        navigation: {
            nextEl: ".portfolio-detail__top-slider .swiper-button-next",
            prevEl: ".portfolio-detail__top-slider .swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            767: {
                slidesPerView: 2,
            },
            1023: {

                slidesPerView: 3,
            },
            1900: {
                slidesPerView: "auto",
            },
        },
    })
    const portfolioBotSlider = new Swiper(".portfolio-detail__bottom-slider", {
        slidesPerView: 1,
        autoHeight: true,
        speed: 1000,
        spaceBetween: 30,
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: ".portfolio-detail__bottom-slider .swiper-button-next",
            prevEl: ".portfolio-detail__bottom-slider .swiper-button-prev",
        },
        pagination: {
            dynamicBullets: true,
            el: ".portfolio-detail__bottom-slider .swiper-pagination",
        },
    })
    const stagesSwiper = new Swiper(".services-detail__stages-slider", {
        loop: true,
        slidesPerView: 1,
        speed: 1500,
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: ".services-detail__stages-slider .swiper-button-next",
            prevEl: ".services-detail__stages-slider .swiper-button-prev",
        },
    })
    const completedSwiper = new Swiper(".completed__slider", {
        loop: true,
        spaceBetween: 70,
        slidesPerView: 2,
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: ".completed__title-block .swiper-button-next",
            prevEl: ".completed__title-block .swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            767: {
                slidesPerView: 2,
            },
        },
    })

    // ОБЫЧНЫЕ СЛАЙДЕРЫ==============================================================================
    const mainBg = document.querySelector(".main__bg")

    function updSwiperNumericPagination(context) {
        document.querySelector(".swiper-pagination-fraction").innerHTML = `<p class="total">${slidesQuantity.toString.length > 1 ? 0 : ""}${slidesQuantity} /</p><span class="count">0${context.realIndex + 1}</span>`
    }

    function doubleRipples() {
        $(".main__bg").ripples("drop", window.innerWidth / 4, window.innerHeight / 2, 30, 0.07)
        setTimeout(() => {
            $(".main__bg").ripples("drop", window.innerWidth / 4, window.innerHeight / 2, 30, 0.07)
        }, 800)
    }

    function changeMainBg(src) {
        mainBg.style.backgroundImage = `url('${src}')`
    }

    function changeTitle(nextSlideCategory, nextSlide) {
        const element = document.querySelector(".swiper-slide-active")
        nextSlideCategory.innerHTML = element.querySelector(".screen__content-category").innerHTML
        nextSlide.setAttribute("href", element.querySelector(".screen__content-title").getAttribute("href"))
    }

    // MAIN SLIDER
    if (document.body.classList.contains("main")) {
        const mainSwiper = new Swiper(".swiper-container", {
            loop: true,
            direction: "vertical",
            effect: "fade",
            preventInteractionOnTransition: true,
            autoplay: {
                delay: 10000,
                // disableOnInteraction: false,
            },
            fadeEffect: {
                crossFade: true,
            },
            speed: 1400,
            mousewheel: {
                forceToAxis: true,
            },
            pagination: {
                el: ".swiper-pagination",
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + "<span></span>" + "</span>"
                },
                clickable: true,
            },
            navigation: {
                nextEl: ".bottom .swiper-button-next",
            },
            on: {
                // Secondary pagination is update after initialization and after slide change
                init: function () {
                    updSwiperNumericPagination(this)
                    let src = this.slides[this.activeIndex].getAttribute("data-background")

                    if (!window.matchMedia("(max-width: 767px)").matches) {
                        try {
                            $(".main__bg").ripples({
                                resolution: 512,
                                perturbance: 0.008,
                                interactive: false,
                                imageUrl: src,
                            })
                        } catch (e) {
                            console.error(e)
                        }
                        doubleRipples()
                    } else {
                        changeMainBg(src)
                    }
                },

                slideChange: updSwiperNumericPagination,
            },
        })

        // притормозить автоплей, если есть лоадер
        if (document.querySelector(".loader__container")) {
            mainSwiper.autoplay.stop()
            setTimeout(() => {
                mainSwiper.autoplay.start()
            }, 6000)
        }
        const nextSlideCategory = document.querySelector(".bottom__next-slide-text span")
        const nextSlide = document.querySelector(".bottom__next-slide")
        const allVideos = document.querySelectorAll('.main__bg video')
        mainSwiper.on("slideChangeTransitionStart", (evt) => {
            mainBg.classList.add("blackout")
            setTimeout(() => {
                mainBg.classList.remove("blackout")
            }, 1300)
            const src = evt.slides[evt.activeIndex].getAttribute("data-background")
            const videoId = evt.slides[evt.activeIndex].getAttribute("data-video")


            setTimeout(() => {
                allVideos.forEach(video => {
                    video.style.display = 'none'
                })
                if (videoId) {
                    let video = document.getElementById(videoId)
                    video.play()
                    video.style.display = "block"
                    changeTitle(nextSlideCategory, nextSlide)
                } else {
                    if (!window.matchMedia("(max-width: 767px)").matches) {
                        //        DESkTOP
                        $(".main__bg").ripples("set", "imageUrl", src)
                        doubleRipples()
                        changeTitle(nextSlideCategory, nextSlide)
                    } else {
                        //        MOBILE
                        changeMainBg(src)
                    }
                }


            }, 1000)
        })

        const elements = document.querySelectorAll(".js-ripples")
        elements.forEach((element) => {
            element.addEventListener("mouseover", (evt) => {
                $(".main__bg").ripples("drop", evt.clientX, evt.clientY, 20, 0.015)
            })
        })
    }
})
